export function metersToMiles(distance) {
    const metersInMile = 1609.344;

    const distanceInMile = distance / metersInMile;
    return Math.round(distanceInMile * 100) / 100
}



// WEBPACK FOOTER //
// ./src/routes/LocalDeals/helpers/distanceHelper.js